module.exports = __webpack_public_path__ + "static/media/icon_game_archero@2x.307960b9.png";